/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'windows': {
    width: 16,
    height: 16,
    viewBox: '0 0 640 640',
    data: '<desc>logo windows</desc><path pid="0" _fill="currentColor" d="M96 157.7l183.6-25.3v177.4H96V157.7zm0 324.6l183.6 25.3V332.4H96v149.9zm203.8 28L544 544V332.4H299.8v177.9zm0-380.6v180.1H544V96l-244.2 33.7z"/>'
  }
})
